import React from 'react';
import PageContainer from '../pagecontainer/PageContainer';
import { ClaimShopSettings, useClaimsShopSettings } from './ClaimsShopSettingsContext';

export const menuItems = [
  {
    id: '/parcel-finder',
    link: '/parcel-finder',
    title: 'Parcel finder',
  },
  {
    id: '/parcel-finder/claims-center',
    link: '/parcel-finder/claims-center',
    matchPaths: ['/parcel-finder/claims-center/*'],
    title: 'Claims center',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/parcel-finder/carrier-claim-payments',
    link: '/parcel-finder/carrier-claim-payments',
    title: 'Carrier claim payments',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/analytics/claims/claim-me-overview',
    link: '/analytics/claims/claim-me-overview',
    title: 'claim.me overview',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/analytics/claims/claims-overview',
    link: '/analytics/claims/claims-overview',
    title: 'Claims overview',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/parcel-finder/start-guide',
    link: '/parcel-finder/start-guide',
    title: 'Start guide',
  },
];

/* eslint-disable indent, no-confusing-arrow */
function getMenuItems(settings: ClaimShopSettings) {
  const items = menuItems.map((item) =>
    item.shopAccess === 'isClaimsEnabled' ? { ...item, disabled: !settings?.isClaimsEnabled } : item
  );

  return settings?.isClaimMeCustomer
    ? items
    : items.filter(
        (item) => !['/parcel-finder/carrier-claim-payments', '/analytics/claims/claim-me-overview'].includes(item.id)
      );
}
/* eslint-enable indent, no-confusing-arrow */

function ParcelFinderContainer(props: { children: React.ReactNode }) {
  const settings = useClaimsShopSettings();
  const menuTitle = settings?.isClaimMeCustomer ? 'claim.me' : 'Parcel Finder + Claims';
  const menuItems = getMenuItems(settings);

  return (
    <PageContainer {...props} menuTitle={menuTitle} menuItems={menuItems}>
      {props.children}
    </PageContainer>
  );
}

export default ParcelFinderContainer;
